import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { IProcedureFee } from 'src/app/models/IProcedureFee';
import { ICptOrdersComponent } from 'src/app/models/ICptOrdersComponent';
import { configuration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProcedureFeeService {

  constructor(private http: HttpClient) { }
  getCPTCodes(): Observable<ICptOrdersComponent[]> {
    return this.http.get<ICptOrdersComponent[]>(`${configuration.apiUrl + 'Master/CPTCodes'}`);
  }

  saveProcedureFeeInfo(procedureFeeInfo: IProcedureFee): Observable<IProcedureFee> {
    return this.http.post<IProcedureFee>(`${configuration.apiUrl + 'Master/ProcedureFee'}`, procedureFeeInfo, {
     // headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getProcedureFee(): Observable<IProcedureFee[]> {
    return this.http.get<IProcedureFee[]>(`${configuration.apiUrl + 'Master/ProcedureFee'}`);
  }

}
